var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _line, _line2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.5 34.5H24.5V33H26.5V34.5ZM26.5 32H24.5C24.5 30.5 22 29 22 27C22 25.07 23.57 23.5 25.5 23.5C27.43 23.5 29 25.07 29 27C29 29 26.5 30.5 26.5 32Z",
    fill: "#1565D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 22H20.5C19.4 22 18.5 22.9 18.5 24V34C18.5 35.1 19.4 36 20.5 36H30.5C31.6 36 32.5 35.1 32.5 34V24C32.5 22.9 31.6 22 30.5 22ZM26.5 34.5H24.5V33H26.5V34.5ZM26.5 32H24.5C24.5 30.5 22 29 22 27C22 25.07 23.57 23.5 25.5 23.5C27.43 23.5 29 25.07 29 27C29 29 26.5 30.5 26.5 32ZM31.5 20.5H19.5C19.5 19.67 20.17 19 21 19H30C30.83 19 31.5 19.67 31.5 20.5ZM30.5 17.5H20.5C20.5 16.67 21.17 16 22 16H29C29.83 16 30.5 16.67 30.5 17.5Z",
    fill: "#1565D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 38L50 -8.74228e-08L52 0L52 38C51.5 38.5 51.5 38.5 51.5 38.5C51.5 38.5 50.3905 38 50 38Z",
    fill: "#1565D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.641 38.3781L39.4493 51.1986C39.098 51.4952 38.4999 51.9999 38.4999 51.9999C38.4999 51.9999 37.6079 50.5577 37.5 50.0001L50.1917 36.9999L51.641 38.3781Z",
    fill: "#1565D8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37115e-8,
    x2: 0.999998,
    y2: 52,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 1,
    y2: 1,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 51L2 51",
    stroke: "#1565D8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxTeam);
export default __webpack_public_path__ + "static/media/cx-team.976402f7ff33040e79911dc61570a4c9.svg";
export { ForwardRef as ReactComponent };